import React from "react";
import WelcomeMeetPage from "components/WelcomeMeetPage";
import "style.css";

const OurTeam: React.FC = () => {
  return (
    <div>
      <WelcomeMeetPage />
    </div>
  );
};

export default OurTeam;
